export class NotificationItem {

    constructor(
        public type: 'error' | 'success' | 'warning',
        public message: string,
        public linkLabel?: string,
        public linkUrl?: string,
    ) {}

}
